import React from "react";

export const About = () => {
  return (
    <div
      id="hero"
      className="relative flex flex-col w-full h-screen space-y-24 overflow-hidden"
    >
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat blur-sm -z-10"
        style={{ backgroundImage: "url('/images/Mission.jpg')" }}
        aria-hidden="true"
      ></div>

      <div
        id="mission"
        className="flex w-full h-full justify-center items-center"
      >
        <div className="relative flex flex-col justify-center text-center h-full hero-text">
          <div className="sm:max-w-xl max-w-xs sm:space-y-6 space-y-6 bg-white/75 text-black rounded-md p-2 sm:p-8 font-montserrat">
            <div className="text-md md:text-2xl font-bold">Миссия</div>
            <p className="text-xs sm:text-sm">
              Способствовать повышению эффективности обучения и развитию
              профессиональных компетенций педагогов с использованием
              инновационных форм преподавания
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
